export default __webpack_public_path__ + "static/media/blue-card.48c2f268.png";